export default "__VITE_ASSET__1dkNnhhB__"